import { render, staticRenderFns } from "./ClinicList.vue?vue&type=template&id=2504ebfa&scoped=true"
import script from "./ClinicList.vue?vue&type=script&lang=js"
export * from "./ClinicList.vue?vue&type=script&lang=js"
import style0 from "./ClinicList.vue?vue&type=style&index=0&id=2504ebfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2504ebfa",
  null
  
)

export default component.exports